export const DATE_SHORT = {
  days: "d",
  weeks: "w",
  month: "M",
  quarter: "Q",
  years: "y",
  hours: "h",
  minutes: "m",
  seconds: "s",
  millisecond: "ms"
};
